import React from 'react';

import lowIcon2 from '@assets/svg/New_Severity_Icons/Low.svg';
import warning from '@assets/svg/New_Severity_Icons/warning_severity.svg';
import info from '@assets/svg/workload/info.svg';
import mediumIcon2 from '@assets/svg/New_Severity_Icons/Medium.svg';
import highIcon2 from '@assets/svg/New_Severity_Icons/High.svg';
import criticalIcon2 from '@assets/svg/New_Severity_Icons/Critical.svg';
import Tooltip from '../v2/ui-elements/Tooltip';

export const SeverityIcons = ({
  severity,
  height = '18px',
  width = '18px',
}: {
  severity: string;
  height?: string;
  width?: string;
}) => {
  switch (severity?.toLowerCase()) {
    case 'critical':
      // return <CriticalIcon width={''} height={height} />;
      return (
        <Tooltip title="Critical" isIcon={true}>
          <img
            src={criticalIcon2}
            style={{
              height: height ?? '',
              width: width ?? '',
            }}
          />
        </Tooltip>
      );
    case 'warning':
      // return <CriticalIcon width={''} height={height} />;
      return (
        <Tooltip title="Warning" isIcon={true}>
          <img
            src={warning}
            style={{
              height: height ?? '',
              width: width ?? '',
            }}
          />
        </Tooltip>
      );

    case 'high':
      // return <HighIcon width={''} height={height} />;
      return (
        <Tooltip title="High" isIcon={true}>
          <img
            src={highIcon2}
            style={{
              height: height ?? '',
              width: width ?? '',
            }}
          />
        </Tooltip>
      );

    case 'medium':
      // return <MediumIcon width={''} height={height} />;

      return (
        <Tooltip title="Medium" isIcon={true}>
          <img
            src={mediumIcon2}
            style={{
              height: height ?? '',
              width: width ?? '',
            }}
          />
        </Tooltip>
      );

    case 'low':
      // return <LowIcon width={''} height={height} />;
      return (
        <Tooltip title="Low" isIcon={true}>
          <img
            src={lowIcon2}
            style={{
              height: height ?? '',
              width: width ?? '',
            }}
          />
        </Tooltip>
      );
    default:
      return (
        <Tooltip title="Info" isIcon={true}>
          <img
            src={info}
            style={{
              height: height ?? '',
              width: width ?? '',
            }}
          />
        </Tooltip>
      );
  }
};

export default SeverityIcons;
